import { TChangePasswordModal } from 'modules/settings/models';
import API from 'services/api';

export const updatePassword = ({ payload }: { payload: TChangePasswordModal }) =>
  API.put(`/api/profile/password-change`, payload);
